import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuillModule } from 'ngx-quill';
import { ReactiveFormsModule } from '@angular/forms';
import { NgfRichTextEditorComponent } from './ngf-rich-text-editor/ngf-rich-text-editor.component';
import { NgfRichTextViewerComponent } from './ngf-rich-text-viewer/ngf-rich-text-viewer.component';
import { NgfDeltaEditorComponent } from './ngf-delta-editor/ngf-delta-editor.component';
import { NgfDeltaViewerComponent } from './ngf-delta-viewer/ngf-delta-viewer.component';
import { NgfAutolinkedTextComponent } from './ngf-autolinked-text/ngf-autolinked-text.component';
import { DialogModule } from '@ng-falcon/dialog/dialog.module';
import { IconsModule } from '@ng-falcon/icons/icons.module';
import { NgfTooltipDirective } from '@ng-falcon/ngf-tooltip/ngf-tooltip.directive';
import { QuillAccessibilityDirective } from '@ng-falcon/ngf-rich-text/quill-accessibility/quill-accessibility.directive';

@NgModule({
  declarations: [
    NgfRichTextEditorComponent,
    NgfRichTextViewerComponent,
    NgfDeltaEditorComponent,
    NgfDeltaViewerComponent
  ],
  imports: [
    CommonModule,
    QuillModule.forRoot(),
    ReactiveFormsModule,
    DialogModule,
    NgfAutolinkedTextComponent,
    IconsModule,
    NgfTooltipDirective,
    QuillAccessibilityDirective
  ],
  exports: [
    NgfRichTextEditorComponent,
    NgfRichTextViewerComponent,
    NgfDeltaEditorComponent,
    NgfDeltaViewerComponent,
    NgfAutolinkedTextComponent
  ]
})
export class NgfRichTextModule { }
